import { VALID_WALLET_LINK_STATUSES } from "@swiggy-private/payment-types";

export enum LinkableWallet {
    PAYTM = "paytm",
    PAYTMPOSTPAID = "paytm_postpaid",
    PHONEPE = "phonepe",
    MOBIKWIK = "mobikwik",
    SIMPL = "paylater_simpl",
    AMAZONPAY = "amazonpay",
}

export interface LinkWalletURIValue {
    checkBalance?: LinkWalletURIValueParams;
    link?: LinkWalletURIValueParams;
    delink: LinkWalletURIValueParams;
    validateOtp?: LinkWalletURIValueParams;
    ssoToken?: LinkWalletURIValueParams;
    calculateChecksum?: LinkWalletURIValueParams;
    loginToken?: LinkWalletURIValueParams;
}

export type LinkWalletURIValueParams = string | { endpoint: string; method: "GET" | "POST" | "DELETE" };
export type LinkWalletURI = {
    [key in LinkableWallet]: LinkWalletURIValue;
};

export interface AddMoneyResponseData {
    url: string;
    params: { [key in string]: string };
}

export interface CheckBalanceApiResponse {
    walletBalance?: string | number;
    balanceamount?: string | number;
    balance?: string | number;
    totalBalance?: string | number;
    mobileNumber?: string;
    isOld?: boolean;
    paymentMethodDisabled?: boolean;
    wallet?: {
        usableBalance: number;
        mobileNumber: string;
        isOld: boolean;
    };
}

export interface LinkWalletParams {
    walletCode: string;
    otp: string;
    otpId?: string;
    state?: string;
}

export interface AddMoneyWalletFormParams extends AddMoneyToWalletParams {
    addMoneyReturnUrl: string;
}

// PAYLATER -> V3
export enum LinkablePayLater {
    LAZYPAY = "PayLater_Lazypay",
    PAYTMPOSTPAID = "PayTM_PostPaid",
    SIMPL = "PayLater_Simpl",
}

export interface LinkPayLaterURIValue {
    isLinked: string;
    link: string;
    delink: string;
    validateOtp: string;
    resendOtp: string;
}

export type LinkPayLaterURI = {
    [key in LinkablePayLater]?: LinkPayLaterURIValue;
};

export interface ValidatePayLaterOtpParams {
    payLaterCode: LinkablePayLater;
    otp: string;
}

// GET BALANCE

export interface GetBalanceResponse {
    linkStatus: VALID_WALLET_LINK_STATUSES;
    balance: string | number;
    mobileNumber: string;
    isOldWalletLinkFlow: boolean;
    paymentMethodDisabled?: boolean;
}

export interface AddMoneyToWalletParams {
    amount: string | number;
    cell: string | number;
    walletCode: string;
    addMoneyReturnUrl?: string;
    isPaymentModeFlow?: boolean;
}

export type AddMoneyWalletCode = LinkableWallet.PAYTM | LinkableWallet.MOBIKWIK;

/* eslint-disable @typescript-eslint/naming-convention */
export interface AmazonPayLinkWalletParams {
    code: string;
    client_id: string;
    redirect_uri: string;
    code_verifier: string;
}

export type WalletLinkExtraParams = AmazonPayLinkWalletParams;

export interface APaySignAndEncryptParams {
    order_id: string | undefined;
    payment_meta: {
        transactionIdType: string;
        transactionId: string;
    };
    payment_method: string;
}

export interface PaytmGenerateChecksumParams {
    CUST_ID: number;
    CHANNEL_ID: string;
    CALLBACK_URL: string;
    THEME: string;
    MID: string;
    INDUSTRY_TYPE_ID: string;
    EMAIL: string;
    MOBILE_NO: string;
    ORDER_ID: string;
    TXN_AMOUNT: string;
    SSO_TOKEN: string;
    REQUEST_TYPE: string;
    WEBSITE: string;
}

export interface PaytmVerifyChecksumParams {
    CHECKSUMHASH: string;
}

export interface PaytmSSOData {
    accessToken: string;
}

export interface MobikwikCheckSumData {
    token: string;
    checksum: string;
    redirectUrl: string;
    orderid: string;
}

export type WalletFormData = PaytmSSOData | MobikwikCheckSumData;
